import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="fixed top-0 left-0 sm:left-[20vw] right-0 z-20 p-4 bg-transparent">
      <a 
        href="#"
        onClick={(e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
        className="inline-block hover:opacity-80 transition-opacity duration-300"
      >
        <img 
          src="/images/tdflogodancers.svg" 
          alt="The Dance Floor Logo" 
          className="h-16 md:h-20"
        />
      </a>
    </header>
  );
};

export default Header;
